import { Box, Dialog, DialogActions, DialogContent } from "@mui/material";
import Button from "@mui/material/Button";

export function OkDialog({ open, text, buttonText, onClose }) {
  return (
    <Dialog open={open}>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: "center", fontWeight: 700 }}>{text}</Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-evenly" }}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={onClose}
          sx={{ textTransform: "uppercase" }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
